import Navigation from '@/components/Navigation/Navigation.vue';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import OpenApp from '@/components/OpenApp/OpenApp.vue';
import Dialog from '@/components/Dialog/Dialog.vue';
import DeviceDetector from "device-detector-js";
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import { loadingIcon } from '@/svg';
import { loginout } from '@/api/login';
import { queryRoleDetail, queryRoleCards, deleteRole } from '@/api/role';
import { report } from '@/api/report';
import { getStorageData } from '@/utils/util';

export default {
	components: {
		Navigation,
		AreaLoading,
		OpenApp,
		Dialog
	},

	data() {
		return {
			pageLoading: false,
			cardsLoading: false,
			loadingIcon,
			showLoginPop: false,
			roleInfo: {},
			cardList: [],
			roleName: '',
			deleteLoading: null
		}
	},

	computed: {
    ...mapGetters(['userName', 'photo', 'isLogin', 'points', 'inviteCode', 'userToken']),
  },

	activated() {
		this.init();
	},

	created() {
    report({
      event_type: 'view',
      event_value: 'role_detail'
    });
  },

	methods: {
		back() {
			this.$router.back();
		},

    async goChat() {
    	const deviceDetector = new DeviceDetector();
      const deviceInfo = deviceDetector.parse(window.navigator.userAgent);
    	const inviteCode = this.inviteCode || '';

    	if (deviceInfo.os.name === 'Android' && this.isLogin) {
    		this.goDownload();
    		return;
    	}

    	this.$router.push({
        path: `/chat/${this.$route.params.roleId}`,
        query: {
        	invite_code: inviteCode,
        	nickname: encodeURIComponent(this.roleName)
        }
      });
      report({
	      event_type: 'click',
	      event_value: 'chat_now'
	    });
    },

    async goDownload() {
    	const inviteCode = this.inviteCode || '';

    	this.$router.push({
        path: `/download`,
        query: {
        	invite_code: inviteCode,
        }
      });
    },

		async init() {
			this.cardsLoading = false;
			this.pageLoading = true;
			this.setNickname();

			try {
				await this.getRoleInfo();
				this.pageLoading = false;
				await this.getCardList();
			}
			catch(err) {
				this.$message({
		      message: err.message || 'Failed to fetch character data.',
		      type: 'error',
		      showClose: true,
		      customClass: 'custom-message',
		    });
			}
		},

		setNickname() {
			const nickname = this.$route.query.nickname || '';

			this.roleName = decodeURIComponent(nickname);
		},

		async getRoleInfo() {
			const res = await queryRoleDetail({
				roleId: this.$route.params.roleId,
				token: this.userToken
			});

			this.roleInfo = res.data;
		},

		async getCardList() {
			this.cardsLoading = true;
			const res = await queryRoleCards({
				roleId: this.$route.params.roleId
			});

			this.cardList = res.data;
			this.cardsLoading = false;
		},

		editRole() {
			this.$router.push({
        path: `/create_character`,
        query: {
        	invite_code: this.inviteCode,
        	character_id: this.$route.params.roleId,
        	edit: true
        }
      });
		},

		deleteRole() {
			this.$refs.delRoleDialog.show();
		},

		cancelDelete() {
			this.$refs.delRoleDialog.hide();
		},

		handleDelCharacter(item) {
			if (item.id === 'cancel') {
				this.cancelDelete();
				return;
			}

			if (item.id === 'comfirm') {
				this.deleteRoleRequest();
			}
		},

		async deleteRoleRequest() {
			this.deleteLoading = Loading.service({
		    fullscreen: true,
	      customClass: 'text-loading',
	      text: 'Deleting...'
		  });
		  this.cancelDelete();

		  try {
		  	const res = await deleteRole({
		  		id: this.roleInfo.id,
		  		token: this.userToken
		  	});

		  	this.deleteLoading.close();

		  	if (res.statusCode === 200) {
		  		this.$message({
			      message: 'Delete successful',
			      type: 'success',
			      showClose: true,
			      customClass: 'custom-message',
			    });
		  		this.$router.replace('/');
		  		return
		  	}

		  	this.$message({
		      message: `delete character fail.`,
		      type: 'error',
		      showClose: true,
		      customClass: 'custom-message',
		    });
		  }
		  catch(err) {
		  	this.$message({
		      message: `delete character fail.`,
		      type: 'error',
		      showClose: true,
		      customClass: 'custom-message',
		    });
		  }

		  this.deleteLoading.close();
		}
	},
}